import React, { useState } from 'react'
import usePageMeta from '../../usePageMeta'
import Card from 'react-bootstrap/Card'

import Swiper from 'react-id-swiper';
import SwiperCore, { Lazy, Navigation, Autoplay, Pagination } from 'swiper'
import OrderModal from '../../components/OrderModal'

import { useProducts } from '../../products'

import PriceImg1 from '../../img/price-img1.webp'
import PriceImg2 from '../../img/price-img2.webp'
import PriceImg3 from '../../img/price-img3.webp'

import HoneyPot from '../../img/honey-pot.svg'
import HoneyItem from '../../img/honey-item.png'
import Nuc from '../../img/nuc.webp'
import Queens from '../../img/queens.webp'
import Pollen from '../../img/price-pollen.webp'
import Comb from '../../img/comb.webp'

import SoldOut from '../../img/soldOut.png'

import 'swiper/swiper-bundle.css';

SwiperCore.use([Lazy, Navigation, Autoplay, Pagination ])

const IMAGES = {
  h1: PriceImg1,
  h3: PriceImg2,
  h7: PriceImg3,
  h15: PriceImg3,
  queens: Queens,
  nuc: Nuc,
  pollen: Pollen,
  comb: Comb,
}


const Products = (props) => {

  usePageMeta(
    'Honey prices - Horobets Bee Ranch, Rimbey Alberta',
    'Raw honey in 1, 3, 7 and 15 kg pails, comb honey, bee pollen, queen bees and 4-frame nucleus colonies. Current prices and availability.',
    '/products'
  )

  const [ showModal, setShowModal] = useState(false)
  const [ product, setProduct ] = useState('')
  const [ volume, setVolume ] = useState('')

  const products = useProducts()

  // What can be bought comes first; within each group the catalogue order from
  // the database stands. The order form keeps the plain catalogue order, where
  // shuffling 1, 3, 7 and 15 kg around would only confuse.
  const cards = [...products].sort(
    (a, b) => Number(a.soldOut) - Number(b.soldOut) || a.sort - b.sort
  )

  const order = (showModal, orderedProduct, orderedVolume) => {
    setShowModal(showModal)
    setProduct(orderedProduct)
    setVolume(orderedVolume)
  }

  const params = {
    // The card order changes when the bot toggles stock. In grid mode Swiper
    // writes each slide's position as an inline style, and those styles move
    // with the nodes React reorders, so it has to recalculate them.
    shouldSwiperUpdate: true,
    grabCursor: true,
    spaceBetween: 10,
    slidesPerView: 1,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    breakpoints: {
      319: {
        slidesPerView: 1.25,
        spaceBetween: 20,
        centeredSlides: true,
      },
      768: {
        slidesPerView: 2.5,
        spaceBetween: 50,
        centeredSlides: true,

      },
      968: {
        slidesPerColumn: 3,
        spaceBetween: 30,
        slidesPerView: 3,
        slidesPerColumnFill: 'row',
      },
    }
  }

  return (
    <div>
      {showModal &&
        <OrderModal showModal={showModal} setShowModal={setShowModal} orderedProduct={product} orderedVolume={volume}/>
      }
      <div className="container container-price" id='price'>
        <h1 className="title">
          Honey
        </h1>
        <div className="row pb30 slider-products" style={{margin: 'auto'}}>

          <Swiper {...params}>
            {cards.map((item) => (
              <div key={item.id}>
                <Card style={{borderRadius: '20px', border:'0px',textAlign:'center'}}>
                  <Card.Img
                    loading="lazy"
                    variant="top"
                    src={IMAGES[item.id]}
                    layout="fill"
                    className={item.soldOut ? 'cover-img cover-img_sold-out' : 'cover-img'}
                    alt={item.text}
                    style={{borderRadius: '20px 20px 0px 0px'}}
                  />
                  {item.soldOut &&
                    <img loading="lazy" src={SoldOut} alt="Sold out" className='sold-out-img'/>
                  }
                  <Card.Body>
                    <Card.Title>
                      <div className="price-card_price">
                        <h4>
                          {item.priceFrom && <><span>From</span>{' '}</>}
                          ${item.price}<span> CAD</span>
                        </h4>
                        <div>
                          {item.honeyPot &&
                            <img loading="lazy"
                              src={HoneyPot}
                              width="18"
                              height="20"
                              alt=''
                            />
                          }
                          <p className="text">{item.unit}</p>
                        </div>
                      </div>
                    </Card.Title>
                    <Card.Text style={{paddingBottom: '1rem'}}>
                      <p className="price-card_text">
                        {item.text}
                      </p>
                    </Card.Text>
                    <div className="price-card_button">
                      <button
                        className="common-button_orange"
                        onClick={() => order(!showModal, item.product, item.volume)}
                        disabled={item.soldOut}
                      >
                        ORDER
                      </button>
                    </div>
                  </Card.Body>
                </Card>
              </div>
            ))}
          </Swiper>

        </div>
      </div>

      <div className="container container-product pb30" id='honey' style={{backgroundColor: '#1E1420'}}>
        <h3 className="title" style={{color: '#0B0A0A'}}>
          About honey
        </h3>
        <div className="row" style={{display: 'inherit', margin: 'auto'}}>
          <div className="product-row">
            <div>
              <img loading="lazy"
                src={HoneyItem}
                width="40"
                height="42"
                alt=""
                sizes="(min-width: 968px) 55px, 40px"
              />
            </div>
            <p>Only <span className="bold-text">100% natural honey</span></p>
          </div>
          <div className="product-row">
            <div>
              <img loading="lazy"
                src={HoneyItem}
                width="40"
                height="42"
                alt=""
                sizes="(min-width: 968px) 55px, 40px"
              />
            </div>
            <p>Raw honey is<span className="bold-text"> unheated, unpasteurized</span></p>
          </div>
          <div className="product-row">
            <div>
              <img loading="lazy"
                src={HoneyItem}
                width="40"
                height="42"
                alt=""
                sizes="(min-width: 968px) 55px, 40px"
              />
            </div>
            <p>Our honey is<span className="bold-text"> directly from the beehive</span></p>
          </div>
          <div className="product-row">
            <div>
              <img loading="lazy"
                src={HoneyItem}
                width="40"
                height="42"
                alt=""
                sizes="(min-width: 968px) 55px, 40px"
              />
            </div>
            <p>
              <span className="bold-text">Delicious way to add a </span> healthy sweet touch to your meal
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Products
